import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {stateFullNames} from '../utils/StateNameToAbbreviation';
import stateAbbreviationToName from '../utils/StateAbbreviationToName'; 

function StatesFilter({ selectedState, onStateChange, includeVermont }) {
  return (
    <FormControl variant="outlined" fullWidth sx={{ width: '260px'}}>
      <InputLabel id="stateSelect-label">Select a State</InputLabel>
      <Select
        labelId="stateSelect-label"
        id="stateSelect"
        value={stateAbbreviationToName(selectedState)}
        onChange={onStateChange}
        label="Select a State"
      >
     
        {stateFullNames.map((stateFullName) => {
          // Conditionally render "Vermont" based on the includeVermont prop
          /*if (stateFullName === 'Vermont' && !includeVermont) {
            return null;
          }*/
          return (
            <MenuItem key={stateFullName} value={stateFullName}>
              {stateFullName}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default StatesFilter;
